<template>
    <v-layout class="account-lockout">
        <v-flex xs12 data-qe-id="login_account-logout_message">
            <div class="account-lockout__message">
                <div>{{loginConstants.accountLockout.ACCOUNT_LOCKOUT_MESSAGE}}</div>
                <div>{{loginConstants.accountLockout.ACCOUNT_ASSISTANCE_MESSAGE}}</div>
            </div>
            <div class="account-lockout__phone">{{contactUsConstants.MEMBER_SERVICES_NUMBER}}</div>
        </v-flex>
    </v-layout>
</template>
<script>
    import { contactUsConstants } from "../../MyAccount/myaccount.constants";
    import { loginConstants } from "../login.constants";

    export default {
        name: 'AccountLockout',
        data() {
            return {
                contactUsConstants,
                loginConstants,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .account-lockout {
        padding-left: 50px !important;

        &__message {
            color: $ypo-gray;
            line-height: 32px;
            font-size: 18px;
        }

        &__phone {
            padding-top: 10px;
            color: $ypo-cta;
            font-size: 20px;
        }
    }

</style>
